import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import slider1 from "../assets/images/slider1.jpg";
import slider2 from "../assets/images/slider2.jpg";
import slider3 from "../assets/images/slider3.jpg";
import slider4 from "../assets/images/slider4.jpg";
import slider5 from "../assets/images/slider5.jpg";
import slider6 from "../assets/images/slider6.jpg";
import slider7 from "../assets/images/slider7.jpg";
import slider8 from "../assets/images/slider8.jpg";
import slider9 from "../assets/images/slider9.jpg";
import slider10 from "../assets/images/slider10.jpg";
import '../styles/ImageSlider.css';

const images = [slider1, slider2, slider3, slider4, slider5, slider6, slider7, slider8, slider9, slider10];

const ImageSlider = () => {
  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000 }}
      loop
      className="w-full h-[500px]" // Adjust height as needed
    >
      {images.map((img, index) => (
        <SwiperSlide key={index} className="flex justify-center items-center">
          <img
            src={img}
            alt={`Slide ${index}`}
            className="w-full h-auto max-h-full object-cover"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ImageSlider;
